'use strict';

app.controller('PreviewCtrl', [
    '$rootScope',
    '$scope',
    '$timeout',
    '$translate',
    '$q',
    '$http',
    'uiGmapIsReady',
    '$stateParams',
    'GoogleMapService',
    'VehicleCollection',
    'UIObjectWindow',
    function(
        $rootScope,
        $scope,
        $timeout,
        $translate,
        $q,
        $http,
        uiGmapIsReady,
        $stateParams,
        GoogleMapService,
        VehicleCollection,
        UIObjectWindow
    ) {
        var $ctrl = this;

        var INFO_WINDOW_NO_ACTION = 0;
        var INFO_WINDOW_OPEN = 1;
        var INFO_WINDOW_CLOSE = 2;

        var ZOOM_OBJECT = 14;

        var VIEW_MODE_OBJECTS = 1;
        var VIEW_MODE_ROUTE = 2;

        var viewMode = VIEW_MODE_OBJECTS;

        function toggleViewMode() {
            viewMode = viewMode === VIEW_MODE_OBJECTS ? VIEW_MODE_ROUTE : VIEW_MODE_OBJECTS;
        }

        $scope.isViewMode = function(mode) {
            return viewMode === mode;
        };

        $scope.isRouteViewMode = function() {
            return $scope.isViewMode(VIEW_MODE_ROUTE);
        };

        $scope.applyIconTransformation = function() {
            var sheet = document.getElementById('stylesheet-transformations');
            var css = '';

            for (var i = 0; i < $scope.markers.length; i++) {
                var transform = $scope.markers[i].transform;
                css +=
                    'img[src="' + transform.image + '"] { transform: rotate(' + String(transform.rotation) + 'deg) } ';
            }
            sheet.innerHTML = css;
        };

        var objectTranslatedStatuses = {};

        [1, 2, 3, 4].map(function(o) {
            $translate(['objects.status.' + o]).then(function(v) {
                objectTranslatedStatuses[o] = v['objects.status.' + o];
            });
        });

        /**
         * Map settings
         */
        $scope.map = GoogleMapService.defaults();
        $scope.map.events = {
            click: function() {
                $scope.$apply();
            },
            idle: function(maps) {
                if (!GoogleMapService.ready()) {
                    return;
                }

                if (GoogleMapService.getZoom() !== maps.getZoom()) {
                    GoogleMapService.setZoom(maps.getZoom());
                    $scope.generateNumberWindows();
                }
            },
        };

        var vehicleCollection = new VehicleCollection();
        $scope.vehicles = vehicleCollection;

        $scope.goToObject = function(vehicle, window, zoom) {
            vehicleCollection.select(vehicle);

            var mapZoom = GoogleMapService.getZoom();

            if (zoom !== void 0 && zoom) {
                mapZoom = zoom;
                GoogleMapService.setZoom(mapZoom);
            }

            switch (window) {
                case INFO_WINDOW_OPEN: {
                    $scope.setWindowCoords(vehicle.location().y, vehicle.location().x);
                    $scope.openWindow();

                    vehicle.getAddress();
                    break;
                }
                case INFO_WINDOW_CLOSE: {
                    $scope.closeWindow();
                    break;
                }
                case INFO_WINDOW_NO_ACTION: {
                    $scope.setWindowCoords(vehicle.location().y, vehicle.location().x);
                    break;
                }
                default:
                    break;
            }

            $scope.owApi.on.resize();
        };

        $scope.changeEventMode = function() {
            uiGlRouteApi.changeEventMode();
        };

        $scope.isMaxSpeedEventMode = function() {
            return uiGlRouteApi.isMaxSpeedEventMode();
        };

        /**
         * Change view mode to object / route
         */
        $scope.changeViewMode = function() {
            toggleViewMode();

            $scope.closeWindow();
            $scope.postDataLoadMapLogic(false);

            uiGlRouteApi.destroy();

            if (viewMode === VIEW_MODE_ROUTE) {
                $scope.drawObjectRoute();
            } else {
                if (!$rootScope.isSmartDevice) {
                    vehicleCollection.unselect();

                    GoogleMapService.extend(
                        vehicleCollection.list().map(function(o) {
                            return {
                                lat: o.location().y,
                                lng: o.location().x,
                            };
                        })
                    );
                }

                $scope.mobileRouteStats = false;

                $timeout.cancel(loadTimeout);
                load();
            }

            return viewMode;
        };

        var uiGlRouteApi = {
            ready: false,
        };

        $scope.uiGlRouteApi = uiGlRouteApi;

        $scope.mobileRouteStats = false;

        $scope.isMobileRouteStats = function() {
            return $scope.mobileRouteStats;
        };

        $scope.changeMobileRouteStats = function() {
            $scope.mobileRouteStats = !$scope.mobileRouteStats;
        };

        $scope.isMobileRoute = function() {
            return $scope.isRouteViewMode();
        };

        $scope.refreshRoute = function() {
            uiGlRouteApi.refresh().then(function(response) {
                delete response.messageId;

                vehicleCollection.getSelected().update(response);

                $scope.generateMarkers();
                $scope.setWindowCoords(response.last.y, response.last.x);
            });
        };

        $scope.drawObjectRoute = function() {
            var start = moment
                .utc()
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
            var end = moment
                .utc()
                .endOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
            var object = {
                id: vehicleCollection.getSelected().id,
                number: vehicleCollection.getSelected().get('number'),
            };

            uiGlRouteApi.setOptions({ object: object, start: start, end: end });
            uiGlRouteApi.draw();

            return true;
        };

        var loadTimeout = null;

        var load = function() {
            var hash = $stateParams.hash;

            if ($scope.isViewMode(VIEW_MODE_ROUTE)) {
                loadTimeout = $timeout(load, 11000);
                return;
            }

            var promise = $http.get('/api/share/' + hash).then(function(response) {
                var objects = Object.values(response.data.data);

                if (!vehicleCollection.loaded) {
                    vehicleCollection.create(objects);
                } else {
                    vehicleCollection.update(objects);
                }

                $scope.postDataLoadMapLogic(!vehicleCollection.loaded);

                if (vehicleCollection.list().length === 1) {
                    vehicleCollection.select(vehicleCollection.collection[0]);
                }

                updateVehiclesShowAddress();

                if (vehicleCollection.isSelected()) {
                    $scope.goToObject(vehicleCollection.getSelected(), INFO_WINDOW_NO_ACTION);
                }

                $owApi.call.change();
            });

            loadTimeout = $timeout(load, 11000);
            return promise;
        };

        $scope.postDataLoadMapLogic = function(extend) {
            if (!GoogleMapService.ready()) {
                return;
            }

            $scope.generateMarkers();
            $scope.generateNumberWindows();

            if (vehicleCollection.isSelected()) {
                return;
            }

            extend &&
                GoogleMapService.extend(
                    vehicleCollection.list().map(function(o) {
                        return {
                            lat: o.location().y,
                            lng: o.location().x,
                        };
                    })
                );
        };

        var statusDirectoryMapping = {
            1: 'active',
            2: 'lost',
            3: 'inactive',
            4: 'engine',
        };

        /**
         * All vehicle markers visible on map
         */
        $scope.markers = [];

        /**
         * Generate all vehicle markers visible on the map
         */
        $scope.generateMarkers = function() {
            var markers = [];
            var list = vehicleCollection.list();

            for (var i in list) {
                var vehicle = list[i];

                if ($scope.isViewMode(VIEW_MODE_ROUTE) && !vehicleCollection.isSelected(vehicle)) {
                    continue;
                }

                if (!vehicle.location().x && !vehicle.location().y) {
                    continue;
                }

                var url = false;
                var icon = {};

                var rotation = vehicle.location().angle;

                var vt = vehicle.type ? vehicle.type : 'car';
                var directory = statusDirectoryMapping[vehicle.status];

                url = '/img/icons/vehicles/' + directory + '/' + vt + '.svg?v=' + i;

                icon = {
                    url: url,
                    anchor: new google.maps.Point(15, 15),
                    scaledSize: new google.maps.Size(30, 30),
                };

                var marker = {
                    id: i,
                    object: vehicle.id,
                    latitude: vehicle.location().y,
                    longitude: vehicle.location().x,
                    icon: icon,
                    transform: {
                        image: url,
                        rotation: rotation,
                    },
                };
                markers.push(marker);
            }

            $scope.markers = angular.copy(markers);
            setVehicleClusters();

            $scope.applyIconTransformation();
        };

        $scope.markerClick = function(gm, en, marker) {
            var vehicle = vehicleCollection.get(marker.object);
            var zoom = $rootScope.isSmartDevice ? ZOOM_OBJECT : false;

            $scope.goToObject(vehicle, INFO_WINDOW_OPEN, zoom);
        };

        $scope.windowOptions = {
            show: false,
            coords: angular.copy($scope.map.center),
            options: {
                boxClass: 'box-object-market-window',
                zIndex: 2,
                disableAutoPan: true,
            },
        };

        $scope.closeWindow = function() {
            $scope.windowOptions.show = false;

            $ctrl.uiObjectWindow.hide();
            updateVehiclesShowAddress();
        };

        $scope.openWindow = function() {
            $scope.windowOptions.show = true;

            $ctrl.uiObjectWindow.show();
            updateVehiclesShowAddress();
        };

        $scope.setWindowCoords = function(lat, lng) {
            $scope.windowOptions.coords = {
                latitude: lat,
                longitude: lng,
            };

            $ctrl.uiObjectWindow.position(lat, lng);
        };

        $scope.numberWindows = [];

        $scope.generateNumberWindows = function() {
            var groups = [];

            for (var key in $scope.numberWindows) {
                $scope.numberWindows[key].close();
            }
            $scope.numberWindows = [];

            var collection = vehicleCollection.list();

            for (var key in collection) {
                var vehicle = collection[key];

                if ($scope.isViewMode(VIEW_MODE_ROUTE) && !vehicleCollection.isSelected(vehicle)) {
                    continue;
                }

                if (!vehicle.location().x && !vehicle.location().y) {
                    continue;
                }

                var location = {
                    y: vehicle.location().y,
                    x: vehicle.location().x,
                };

                var offset = 0;
                var column = 0;
                for (var i in groups) {
                    var list = groups[i];
                    for (var j in list) {
                        var obj = list[j];
                        if (vehicle.id === obj.id) {
                            offset = obj.offset;
                            column = obj.column;
                            location = obj.location;
                            break;
                        }
                    }
                }

                var box = document.createElement('div');

                var name = vehicle.get('number');
                name = name ? name : '- ' + vehicle.get('number') + ' -';

                var vt = vehicle.status;

                box.setAttribute('data-id', '' + vehicle.id + '');
                box.innerHTML =
                    '<div class="bubble bubble-' +
                    vehicle.id +
                    (offset > 0 || column > 0 ? ' without-arrow' : '') +
                    ' "> ' +
                    '   <div class="bl-name bl-status bl-status-' +
                    vt +
                    '">' +
                    name +
                    '   </div>' +
                    '</div>';

                box.onclick = function() {
                    var id = parseInt(this.getAttribute('data-id'));
                    var vehicle = vehicleCollection.get(id);

                    $scope.goToObject(vehicle, INFO_WINDOW_OPEN, ZOOM_OBJECT);
                    $scope.$apply();
                };

                var numberWindow = new InfoBox({
                    boxClass: 'box-object-number-window',
                    zIndex: 1,
                    disableAutoPan: 'false',
                    content: box,
                    visible: true,
                });

                numberWindow.setPosition(new google.maps.LatLng(location.y, location.x));
                numberWindow.open(GoogleMapService.get());

                $scope.numberWindows.push(numberWindow);
            }
        };

        function setVehicleClusters() {
            vehicleCollection.list().forEach(function(vehicle) {
                vehicle.bounds = GoogleMapService.getBounds(vehicle.location().y, vehicle.location().x);
                vehicle.cluster = null;
            });

            vehicleCollection.list().forEach(function(vehicle) {
                vehicleCollection.cluster(vehicle);
            });
        }

        var updateVehiclesShowAddress = function() {
            vehicleCollection.list().forEach(function(vehicle) {
                vehicle.address.show = false;

                if (vehicleCollection.isSelected(vehicle)) {
                    vehicle.address.show = true;
                }
            });
        };

        var $owApi = {
            data: {
                modes: ['general', 'can', 'route'],
            },
            fn: {
                close: function() {
                    $scope.isViewMode(VIEW_MODE_OBJECTS) && vehicleCollection.unselect();
                    $scope.closeWindow();
                },
                route: $scope.changeViewMode,
                isRouteMode: $scope.isRouteViewMode,
            },
            on: {
                resize: function() {
                    if (!GoogleMapService.ready() || !vehicleCollection.isSelected()) {
                        return false;
                    }
                    $timeout(function() {
                        var wo = angular.copy($scope.windowOptions);
                        var point = GoogleMapService.getWindowOffset(
                            wo.coords.latitude,
                            wo.coords.longitude,
                            '.' + wo.options.boxClass
                        );
                        GoogleMapService.panTo(point.lat(), point.lng());
                    }, 100);
                },
            },
            call: {
                change: function() {},
            },
        };

        $scope.owApi = $owApi;

        /**
         * UIObjectWindow
         */
        $ctrl.uiObjectWindow = null;

        var uiReady = function() {
            return $q.all([uiGmapIsReady.promise()]);
        };

        var gMapPromise = function() {
            return uiReady().then(function() {
                GoogleMapService.set($scope.map);
                uiGlRouteApi.init(GoogleMapService.get(), []);
            });
        };

        function init() {
            gMapPromise()
                .then(function() {
                    load();
                })
                .then(function() {
                    if (!$ctrl.uiObjectWindow) {
                        var center = $scope.map.center;

                        $ctrl.uiObjectWindow = new UIObjectWindow();
                        $ctrl.uiObjectWindow
                            .compile($scope)
                            .position(center.latitude, center.longitude)
                            .open(GoogleMapService.get());
                    }
                });
        }

        init();

        $scope.$on('$destroy', function() {
            $timeout.cancel(loadTimeout);
        });
    },
]);
